import React, { useState, useRef, useEffect } from "react";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { FileUpload } from "primereact/fileupload";
import { Toast } from "primereact/toast";
import { ProgressSpinner } from "primereact/progressspinner";
import ComplaintService from "../../services/complaint/ComplaintService";
import {
  CreateComplaintRequestDTO,
} from "../../models/complaints/complaint-model";
import "./CustomerserviceComplaintregister.css";
import { MenuType } from "../../types/enum";
import { usePageNavigation } from "../user-menu/menu/navigation";

interface CustomerserviceComplaintregisterProps {
  onSuccess?: () => void;
}

enum ComplaintTypeEnum {
  Internal = 1,
  Product = 2,
  Service = 3,
}

const CustomerserviceComplaintregister: React.FC<
  CustomerserviceComplaintregisterProps
> = ({ onSuccess }) => {
  const toast = useRef<Toast>(null);
  const fileUploadRef = useRef<any>(null);
  const navigateToPage = usePageNavigation();

  // State
  const [description, setDescription] = useState<string>("");
  const [attachments, setAttachments] = useState<File[]>([]);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [isLoading, setIsLoading] = useState(false);
  const [loginUser, setLoginUser] = useState<any>(null);

  useEffect(() => {
    const loginData = localStorage.getItem("user");
    if (loginData) {
      setLoginUser(JSON.parse(loginData));
    }
  }, []);

  const validateForm = (): boolean => {
    const newErrors: { [key: string]: string } = {};
    if (!description || description.trim().length < 10) {
      newErrors.description = "Min. 10 characters required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleFileUpload = (e: any) => setAttachments(Array.from(e.files || []));
  const handleFileRemove = (e: any) => setAttachments(attachments.filter(f => f.name !== e.file.name));
  const handleUploadClear = () => setAttachments([]);

  const handleSubmit = async () => {
    if (!validateForm()) return;
    try {
      setIsLoading(true);
      const payload: CreateComplaintRequestDTO = {
        complaintTypeId: ComplaintTypeEnum.Service,
        description: description,
        priority: "Medium",
        customerId: loginUser.userID,
      };

      const response = await ComplaintService.createComplaintV2({ ...payload, attachments });

      if (response.isSuccess) {
        toast.current?.show({ severity: 'success', summary: 'Success', detail: 'Ticket raised successfully' });
        resetForm();
        onSuccess ? onSuccess() : navigateToPage(MenuType.ViewAllComplaints);
      } else {
        toast.current?.show({ severity: 'error', summary: 'Error', detail: response.message || 'Failed' });
      }
    } catch (e: any) {
      toast.current?.show({ severity: 'error', summary: 'Error', detail: e?.message || 'Error occurred' });
    } finally {
      setIsLoading(false);
    }
  };

  const resetForm = () => {
    setDescription("");
    setAttachments([]);
    setErrors({});
    fileUploadRef.current?.clear();
  };

  return (
    <div className="minimal-form">
      {isLoading ? (
        <div className="loading-state">
          <ProgressSpinner strokeWidth="3" />
          <p>Registering ticket...</p>
        </div>
      ) : (
        <>
          <div className="form-content">
            <div className="field">
              <label>Description <span className="req">*</span></label>
              <InputTextarea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                className={`w-full ${errors.description ? "p-invalid" : ""}`}
                placeholder="Explain the issue..."
                rows={4}
                style={{ border: "1px solid #ced4da", borderRadius: "4px" }}
 
              />
              {errors.description && <small className="p-error">{errors.description}</small>}
            </div>

            <div className="field">
              <label>Attachments</label>
              <FileUpload
                ref={fileUploadRef}
                name="attachments"
                multiple
                auto={false}
                customUpload
                onSelect={handleFileUpload}
                onRemove={handleFileRemove}
                onClear={handleUploadClear}
                emptyTemplate={<p className="empty-text">Drop files here</p>}
                chooseOptions={{ label: "Select Files", icon: "pi pi-plus", className: "minimal-choose" }}
                uploadOptions={{ className: "hidden" }}
                cancelOptions={{ className: "hidden" }}
              />
            </div>
          </div>

          <div className="form-footer ">
          
            <Button label="Submit Complaint" onClick={handleSubmit} loading={isLoading} className="submit-btn" />
          </div>
        </>
      )}
      <Toast ref={toast} />
    </div>
  );
};

export default CustomerserviceComplaintregister;
